import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["calendar"]

  connect() {
    // Check if we have a hash in the URL
    if (window.location.hash === "#datas-e-eventos") {
      this.waitForCalendarButton();
    }
  }

  waitForCalendarButton() {
    const calendarButton = document.getElementById("calendar-button");
    if (calendarButton) {
      // Se o botão já existe, espera um momento para garantir que a página está carregada
      setTimeout(() => {
        calendarButton.click();
      }, 100);
      return;
    }

    // Se o botão não existe, cria um observer para esperar ele ser criado
    const observer = new MutationObserver((mutations, obs) => {
      const calendarButton = document.getElementById("calendar-button");
      if (calendarButton) {
        // Quando encontrar o botão, espera um momento e clica
        setTimeout(() => {
          calendarButton.click();
        }, 100);
        obs.disconnect(); // Para de observar
      }
    });

    // Configura o observer para observar mudanças em todo o DOM
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Por segurança, desconecta o observer após 5 segundos
    setTimeout(() => {
      observer.disconnect();
    }, 5000);
  }
}